module.exports = __webpack_public_path__ + "static/media/droopy_lower.ac9f8e40.svg";